import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { Document24Regular, Folder24Regular } from "@fluentui/react-icons";
import FileListItem from "./FileListItem";
import { getDocStore } from "../taskpane";

export interface TFileListItem {
  icon: React.JSX.Element;
  primaryText: string;
  path: string;
  isDirectory: boolean;
  isSelected?: boolean;
  child?: React.JSX.Element;
  onClick?: () => void;
}

export interface Props {
  path: string;
  level?: number;
  searchQuery?: string;
}

export interface DocumentStore {
  directories: Array<{
    name: string;
    link: string;
  }>;
  files: Array<{
    name: string;
  }>;
  level: number; // 0 is root, 1 is first level directory, etc.
  download_all_link?: string; // optional link to download all files in the current directory
}

const useStyles = makeStyles({
  list: {
    marginTop: "10px",
    paddingLeft: "0",
  },

  welcome__main: {
    display: "flex",
    flexDirection: "column",
  },
});

const FileList: React.FC<Props> = ({ path, level, searchQuery }: Props) => {
  const [docStore, setDocStore] = React.useState<DocumentStore>(null);
  const [selectedItem, setSelectedItem] = React.useState<string>(null);

  const styles = useStyles();

  async function fetchDocuments() {
    const data = await getDocStore(path);
    setDocStore(data);
  }

  React.useEffect(() => {
    void fetchDocuments();
  }, []);

  function fileListItems(): TFileListItem[] {
    return [
      ...docStore.directories.map((dir) => {
        const isSelected = dir.name === selectedItem;

        return {
          icon: <Folder24Regular />,
          primaryText: dir.name,
          path,
          level,
          link: dir.link,
          isSelected,
          isDirectory: true,
          canUpload: level === 2,
          canSearch: level === 1,
          onClick: () => {
            if (selectedItem === dir.name) {
              setSelectedItem(null);
            } else {
              setSelectedItem(dir.name);
            }
          },
        };
      }),
      ...docStore.files.map((file) => {
        return {
          icon: <Document24Regular />,
          primaryText: file.name,
          path,
          isDirectory: false,
          isSelected: false,
          onClick: () => {},
        };
      }),
    ];
  }

  function listItems() {
    const items = searchQuery
      ? fileListItems().filter((item) => item.primaryText.toLowerCase().includes(searchQuery))
      : fileListItems();
    return items.map((item, index) => <FileListItem key={index} {...item} />);
  }

  function marginLeft() {
    return `${(level - 1) * 10}px`;
  }

  return (
    <div className={styles.welcome__main} style={{ marginLeft: marginLeft() }}>
      {docStore && <ul className={styles.list}>{listItems()}</ul>}
    </div>
  );
};

export default FileList;
